import type IBlogPost from "@api/models/IBlog";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, ThemeIcon } from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import { IconCalendarEvent } from "@tabler/icons-react";
import dayjs from "dayjs";
import { useMemo } from "react";

interface Props {
  blog?: IBlogPost;
}

const UpdatedAt: React.FC<Props> = ({ blog }) => {
  const { t } = useAppTranslation("pages.blog");

  const updatedAt = useMemo(() => {
    if (blog?.updatedAt) {
      return t("updatedAt", { date: dayjs(blog.updatedAt).toDate() });
    }
  }, [blog?.updatedAt, t]);

  return (
    <Group className="text-primary-dark-text text-sm" gap={5}>
      <ThemeIcon
        autoContrast
        className="text-primary-dark-text"
        variant="transparent"
      >
        <IconCalendarEvent />
      </ThemeIcon>
      <AppSkeleton>
        <span>{updatedAt}</span>
      </AppSkeleton>
    </Group>
  );
};

export default UpdatedAt;
